module.exports = __webpack_public_path__ + "static/media/galerija_2014 (8).efd284a7.jpg";